import AnimatedSubRoutes from "@app/components/routing/AnimatedSubRoutes/AnimatedSubRoutes"
import ProtectedRoute from "@app/components/routing/ProtectedRoute/ProtectedRoute"
import AddressDetails from "@app/pages/funnel/order/AddressDetails/AddressDetails"
import BluphoriaSelection from "@app/pages/funnel/order/BluphoriaSelection/BluphoriaSelection"
import DateSelection from "@app/pages/funnel/order/DateSelection/DateSelection"
import { LoungerMapSelection } from "@app/pages/funnel/order/LoungerMapSelection/LoungerMapSelection"
import LoungerSelection from "@app/pages/funnel/order/LoungerSelection/LoungerSelection"
import OrderOverview from "@app/pages/funnel/order/OrderOverview/OrderOverview"
import OrderOverview2 from "@app/pages/funnel/order/OrderOverview2/OrderOverview2"
import PaymentMethods from "@app/pages/funnel/order/PaymentMethods/PaymentMethods"
import PersonTypesPage from "@app/pages/funnel/order/PersonTypes/PersonTypesPage"
import SaunaBoat from "@app/pages/funnel/saunaBoat/SaunaBoat"
import { Route } from "react-router"

export default function OrderNavigation() {
	return (
		<AnimatedSubRoutes>
			<Route path="order/person-types" element={<PersonTypesPage />} />
			<Route path="order/date-selection" element={<DateSelection />} />
			<Route path="order/lounger-selection" element={<LoungerSelection />} />
			<Route path="order/loungermap-selection" element={<LoungerMapSelection />} />
			<Route path="order/bluphoria-selection" element={<BluphoriaSelection />} />
			<Route path="order/order-overview" element={<OrderOverview />} />
			<Route
				path="order/payment-methods"
				element={
					<ProtectedRoute path="order/payment-methods">
						<PaymentMethods />
					</ProtectedRoute>
				}
			/>
			<Route path="order/address-details" element={<AddressDetails />} />
			<Route path="order/next-order-overview" element={<OrderOverview2 />} />
			<Route path="order/sauna-boat" element={<SaunaBoat />} />
		</AnimatedSubRoutes>
	)
}
